import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { BankService } from '../../../service/bank/bank.service';
import { Bank } from '../../../class/bank';

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss']
})
export class BankComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoBank: Bank;
    public bank: Bank;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public bankService: BankService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelBank () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/banks/bank/bank.component.ts